import { AxiosResponse } from 'axios';
import { useQuery } from 'react-query';
import axios from 'libs/Axios';

import { AxiosDefaultErrorEntity } from 'types/api/Common/ErrorTypes';
import { RowenaDisplayContent } from 'types/api/SystemTenant/RowenaAI/RowenaContentTypes';

export const ROWENA_CONTENT_QUERY_KEY = {
  ROWENA_CONTENT_DISPLAY: 'ROWENA_CONTENT_DISPLAY',
};

export interface RowenaDisplayContext {
  measure?: { cubeAttributeId: string };
  timePeriod?: { value: string };
  totalPeriod?: { value: number };
}

export function useGetDisplayRowenaContent(workFlowId?: string, context?: RowenaDisplayContext) {
  return useQuery<AxiosResponse<RowenaDisplayContent>, AxiosDefaultErrorEntity>(
    [ROWENA_CONTENT_QUERY_KEY.ROWENA_CONTENT_DISPLAY, workFlowId, context],
    () =>
      axios
        .post(`/api/v1/tenant/rowena/display-content/${workFlowId}`, context ? { context } : undefined)
        .then((res) => res),
    {
      enabled: !!workFlowId,
    }
  );
}
